<div class="app-input-dropdown">
  <div *ngIf="disabled" class="app-input-dropdown-disabled-overlay"></div>
    <div [ngClass]="{'inline-form-field': inline}">
    <label *ngIf="label||tooltip" class="app-input-dropdown-label app-label"
      >{{ label }}
      <ng-container *ngIf="isRequired">*</ng-container>

      <i
        style="padding-left: 5px"
        tooltipPosition="top"
        pTooltip="{{ tooltip }}"
        *ngIf="tooltip"
        class="fa-solid fa-circle-question text-link-color"
      ></i>
    </label>    

    <p-select [appendTo]="appendTo" ngDefaultControl [ngClass]="{ 'full-width': shouldBeFullWidth }" [placeholder]="placeholder" [options]="options" [formControl]="control"
    optionValue="value" 
    optionDisabled="disabled"
    [disabled]="disabled"

    >
  
    <ng-template #selectedItem let-selectedOption>
      {{selectedOption.text}}
    </ng-template>

    <ng-template let-op #item>
      {{op.text}}
    </ng-template>
  
  </p-select>
  </div>
  <!-- <div class="input-error-content-wrapper">
    <span class="input-error-color input input-error-content" *ngIf="error">
      <i class="fa-solid fa-triangle-exclamation"></i>
      {{ errorMessage }}
    </span>
  </div> -->
</div>
